import { FlowNodeBase } from './FlowNodeBase';
import { FlowNodeResourceChips } from './FlowNodeResourceChips';

interface FlowLLMNodeData {
  label: string;
  status: string;
  config: {
    responseFormat?: string;
    outputKey?: string;
    model?: string;
    providerSecretId?: string;
  };
}

export function FlowLLMNode({ data, selected }: { data: FlowLLMNodeData; selected?: boolean }) {
  const hasFooter = Boolean(data.config.responseFormat || data.config.outputKey);
  return (
    <FlowNodeBase
      nodeType="llm"
      label={data.label}
      selected={selected}
      isActive={data.status === 'running'}
      status={data.status}
      footer={
        hasFooter ? (
          <>
            {data.config.responseFormat === 'json' ? 'JSON' : 'Text'}
            {data.config.outputKey && data.config.outputKey !== 'response'
              ? ` → ${data.config.outputKey}`
              : ''}
          </>
        ) : undefined
      }
    >
      <FlowNodeResourceChips
        model={data.config.model}
        providerSecretId={data.config.providerSecretId}
        slots={{ model: true, providerKey: true }}
      />
    </FlowNodeBase>
  );
}
